import api from "../middlware/api";
import { BASE_URL } from "../constants";
import {
  InsuranceProviderFormData,
} from "../interfaces/insuranceProviders";
import { camelToSnake } from "../utils/CamelToSnake";

// CREATE Insurance Provider
export const createInsuranceProvider = (payload: InsuranceProviderFormData) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/insurance-providers`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET all Insurance Providers
export const getInsuranceProviders = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/insurance-providers`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET single Insurance Provider
export const getInsuranceProviderById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/insurance-providers/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// UPDATE Insurance Provider
export const updateInsuranceProvider = (
  id: number | string,
  payload: InsuranceProviderFormData
) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/insurance-providers/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

